import { get as getSite } from 'psl';

// The company domains, shared auth included. Apps on their own domains (manabua, quizter, ...) are
// covered by the same-site check below instead of a list here.
const COMPANY_DOMAIN = /(^|\.)(ilteducation|inlasningstjanst|sondo)\.[a-z.]+$/;

// Marketing sites (www.polylino.se, www.inlasningstjanst.se) and the portal (app.ilteducation.*,
// manage.sondo.fr) are ways in we want to see, even on a company domain or the app's own site.
const ENTRY_POINT = /^(www|app|app-dev|manage|manage-dev)\./;

/**
 * Reduces document.referrer to the origin of the external page the visitor came from, e.g.
 * https://www.facebook.com. Paths and query strings are dropped on purpose: they can carry search
 * terms or tokens, and the origin is enough to see where shared links travel.
 *
 * Dropped as not external: the company domains, and any page on the same site as the app itself
 * (auth.manabua.com for app.manabua.com) - a login round trip, not a way in. Except the marketing
 * sites and the portal, unless that is the app's own host.
 *
 * android-app:// referrers (Gmail, WhatsApp, ...) have no URL origin, so scheme and host are kept
 * instead.
 */
export const toExternalReferrer = (referrer: string, appHostname: string): string | undefined => {
  try {
    const { protocol, host, hostname } = new URL(referrer);
    const isSameSite = (getSite(hostname) ?? hostname) === (getSite(appHostname) ?? appHostname);

    const isEntryPoint = ENTRY_POINT.test(hostname) && hostname !== appHostname;
    const isExternal = !isSameSite && !COMPANY_DOMAIN.test(hostname);

    return host && (isEntryPoint || isExternal) ? `${protocol}//${host}` : undefined;
  } catch {
    return undefined;
  }
};
